<template>
  <div :class="classObject">
    <div class="topPagination">
      <div class="topPagination-content">
        <div v-for="item in splitArray" :key="item.name" class="datas">
          <el-button size="medium" @click="activeChange(item)">
            <div class="datas-label" :title="item.name">{{ item.name }}</div>
          </el-button>
        </div>
      </div>
      <div v-if="listData.length > splitNum" class="topPagination-pagination">
        <el-pagination
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          hide-on-single-page
          layout="prev, pager, next"
          :page-size="splitNum"
          :total="listData.length"
          :small="smallPagination"
        >
        </el-pagination>
      </div>
    </div>
    <div class="content">
      <div
        class="content-video"
        style="width: 100%; height: 250px; display: inline-block"
      >
        <el-image
          v-if="notPlay"
          style="width: 100%; height: 100%"
          :src="require('@/assets/images/video/noVideo.svg')"
          fit="fill"
        ></el-image>
        <VideoPlayer
          v-else
          :url="videoUrl"
          :isLive="isLive"
          :id="videoId"
          ref="videoRef"
          controls
        />
      </div>
      <template v-if="hasReplay && !notPlay">
        <div class="content-date">
          <DateTimePicker @dateChange="dateChange" />
        </div>
        <div class="content-control">
          <div>
            <el-button size="medium" @click="changePlayType">{{
              isLive ? "回放" : "直播"
            }}</el-button>
          </div>
          <div>
            <el-button size="medium" @click="changePlay">{{
              isPlay ? "暂停" : "播放"
            }}</el-button>
          </div>
          <div v-if="!isLive">
            <Rate :domId="videoId" />
          </div>
          <div>
            <el-button size="medium" @click="fullScreen">全屏</el-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const classNames = require("classnames");
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
import Rate from "@/components/VideoPlayer/Rate";
import DateTimePicker from "@/components/DatePicker/DateTimePicker";
import api from "@/api";
import { getProjectVal } from "@/assets/js/utils";
export default {
  name: "VideoPlayerWithPagination",
  props: {
    className: {
      type: String,
      default: "",
    },
    splitNum: {
      type: Number,
      default: 4,
    },
    smallPagination: {
      type: Boolean,
      default: false,
    },
    stationId: {
      type: String,
      default: "",
    },
    // inverterId: {
    //     type: String,
    //     default: ""
    // },
    hasReplay: {
      type: Boolean,
      default: false,
    },
    videoId: {
      type: String,
      default: "videoFlvWithPagination",
    },
    //光伏，配电
    systemType: {
      type: String,
      default: "光伏",
    },
    assetId: {
      type: String,
      default: "",
    },
  },
  components: {
    VideoPlayer,
    Rate,
    DateTimePicker,
  },
  data() {
    return {
      currentPage: 1,
      listData: [],
      activeItem: {
        url: "",
        urlBack: "",
      },
      notPlay: true,
      timeFormatStr: "",
      isLive: true,
      isPlay: false,
      visibleRate: false,
      //当前播放速率
      rate: 1.0,
    };
  },
  computed: {
    classObject: function () {
      return classNames({
        videoPlayerWithPagination: true,
        [this.className]: !!this.className,
      });
    },
    videoUrl: function () {
      return this.isLive ? this.activeItem.url : this.activeItem.urlBack;
    },
    splitArray: function () {
      return this.listData.slice(
        (this.currentPage - 1) * this.splitNum,
        this.currentPage * this.splitNum
      );
    },
    ids: function () {
      return this.systemType === "光伏"
        ? {
            stationId: this.stationId,
            inverterId: this.inverterId,
          }
        : this.assetId;
    },
  },
  watch: {
    videoUrl(val) {
      if (!val) {
        this.notPlay = true;
      } else {
        if (this.notPlay) {
          this.notPlay = false;
        } else {
          this.isPlay = false;
          // this.$refs.videoRef.videoGetExeStatus()
        }
      }
    },
    ids() {
      this.getCameraInfo();
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    //监控列表
    async getCameraInfo() {
      this.notPlay = true;
      if (this.systemType === "光伏") {
        const res = await api.PVOSGetCameraInfo({
          projectId: !this.stationId ? getProjectVal("Id") : null,
          stationId: !!this.stationId ? this.stationId : null,
        });
        if (res && res.data.code == 200) {
          console.log(res.data.data, "res.data.data-----");
          const newData = res.data.data;
          this.listData = newData;
        } else {
          console.log("获取监控列表失败");
        }
      } else {
        const res = await api.DSGetDistributingPvList({
            assetId:this.assetId,
            deviceTypes:'枪机摄像头',
            page:0,
            pageSize:10000,
            needAll:true,
        });
        if (res && res.data.code == 200) {
          console.log(res.data.data.data, "res.data.data.data-----");
          const newData = res.data.data.data;
          this.listData = newData;
        } else {
          console.log("获取监控列表失败");
        }
      }
    },
    activeChange(data) {
      this.activeItem = {
        ...data,
        url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${data?.RTSP || ""}`,
        urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(
          data?.RTSP || ""
        ).replace("Channels", "tracks")}?${this.timeFormatStr}`,
      };
    },
    dateChange(value) {
      if (value) {
        const starttime = this.$moment(value[0]).format("YYYYMMDDTHHmmss[Z]");
        const endtime = this.$moment(value[1]).format("YYYYMMDDTHHmmss[Z]");
        const newStr = `starttime=${starttime}&endtime=${endtime}`;
        this.timeFormatStr = newStr;
        const urlBackArr = this?.activeItem?.urlBack.split("starttime=");
        this.activeItem.urlBack = `${urlBackArr[0]}${newStr}`;
      } else {
        this.timeFormatStr = "";
        this.activeItem.urlBack = `${urlBackArr[0]}`;
      }
    },
    changePlayType() {
      this.isLive = !this.isLive;
      this.isPlay = false;
    },
    changePlay() {
      if (this.isPlay) {
        this.$refs.videoRef.player.pause();
      } else {
        this.$refs.videoRef.player.play();
      }
      this.isPlay = !this.isPlay;
    },
    fullScreen() {
      const element = document.getElementById(this.videoId);
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
  },
  created() {
    this.getCameraInfo();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.videoPlayerWithPagination {
  width: 100%;
  height: 100%;

  .topPagination {
    height: 150px;

    &-content {
      height: 100px;
      width: 100%;
      @include setFlexBetween;
      flex-wrap: wrap;
      align-items: flex-start;

      .datas {
        width: 50%;
        text-align: center;

        &-label {
          @include setEllipsis;
        }

        & button {
          width: 96%;
          margin: auto;
        }
      }
    }

    &-pagination {
      height: 35px;
      text-align: center;
      margin-top: 15px;
    }
  }

  .content {
    margin-top: 10px;

    &-video {
    }

    &-date {
      margin-top: 30px;
    }

    &-control {
      margin-top: 30px;
      width: 100%;
      @include setFlexBetween;
    }
  }
}
</style>
